import React from "react";

export function PrizeMoneySection({ prizeMoney, formatter }) {
    return (
        <section
            aria-label="Prize money"
            className="prize-money rounded-xl border border-masters-moss/35 bg-masters-pine/25 p-6 text-masters-cream shadow-lg shadow-black/15"
        >
            <div className="text-center text-lg font-semibold tracking-wide text-masters-cream">
                Prize money
            </div>
            <div className="pb-5 pt-1 text-center text-sm text-masters-goldmuted">
                (2025 payouts: $21m total)
            </div>
            <ul className="mx-auto max-w-xs space-y-1 text-sm">
                {prizeMoney.map((amount, index) => (
                    <li
                        key={index}
                        className="flex justify-between gap-4 rounded-lg border border-transparent px-2 py-1.5 odd:bg-masters-forest/25 hover:border-masters-gold/15"
                    >
                        <span className="text-masters-parchment">
                            {index + 1}
                        </span>
                        <span className="font-medium tabular-nums text-masters-cream">
                            {formatter.format(amount)}
                        </span>
                    </li>
                ))}
            </ul>
        </section>
    );
}
